import { makeStyles } from '@material-ui/core';
import { COLORS } from 'constants/index';

interface StyleProps {
  hasActions: boolean;
  noCardPadding?: boolean;
}

const useStyles = makeStyles({
  listItem: {
    paddingRight: '72px',
    paddingBottom: '16px',
    paddingTop: '16px',
    '&:hover': {
      backgroundColor: COLORS.WHITE,
    },
  },
  cardContent: {
    paddingBottom: ({ hasActions }: StyleProps) => (hasActions ? '0' : '16px'),
    paddingLeft: '16px',
    paddingRight: '0',
    padding: ({ noCardPadding }: StyleProps) => (noCardPadding ? '0' : ''),
  },
  listItemText: {
    marginLeft: '8px',
    '&:first-of-type': {
      marginBottom: 0,
    },
  },
  listItemTextContainer: {
    overflowX: 'hidden',
  },
});

export default useStyles;
